export class DocumentUploadOptions {
    public static get portalCSV() {
        return [
        {
            key: "Third Party Cash",
            name: 'Third Party Cash',
            fileTypes: ['csv', 'xlsx']
        },{
            key: "Third Party Purchase",
            name: 'Third Party Purchase',
            fileTypes: ['csv', 'xlsx']
        }, {
            key: "USAT Invoice File",
            name: 'USAT Invoice File',
            fileTypes: ['csv', 'xlsx']
        }, {
            key: "Winfactor Clients",
            name: 'Winfactor Clients',
            fileTypes: ['csv', 'xlsx']
        }, {
            key: "Winfactor Client Contacts",
            name: 'Winfactor Client Contacts',
            fileTypes: ['csv', 'xlsx']
        }, {
            key: "Winfactor Customers (Debtors)",
            name: 'Winfactor Debtors',
            fileTypes: ['csv', 'xlsx']
        }, {
            key: "Winfactor Customers (Debtors) Contacts",
            name: 'Winfactor Debtors Contacts',
            fileTypes: ['csv', 'xlsx']
        }, {
            key: "Winfactor Invoices",
            name: 'Winfactor Invoices',
            fileTypes: ['csv', 'xlsx']
        }, {
            key: "Winfactor Receipts (Payments)",
            name: 'Winfactor Payments',
            fileTypes: ['csv', 'xlsx']
        }, {
            key: "Winfactor Settlement",
            name: 'Winfactor Settlement',
            fileTypes: ['csv', 'xlsx']
        }, {
            key: "WinFactor Wires",
            name: 'WinFactor Wires',
            fileTypes: ['csv', 'xlsx', 'txt']
        }
        ]
    }
}



// WEBPACK FOOTER //
// ./src/app/core/constants/DocumentUploadOptions.ts